<template>
  <div id="confirmLoading">
    <div id="wrapper">
      <div class="v-align">
        <div class="background"></div>
        <div class="loader">
          <aside class="loader__box loader--left">
            <span class="loader__circle">
              <i class="fas fa-home fa-rotate-180"></i>
            </span>
          </aside>
          <aside class="loader__box loader--right">
            <span class="loader__circle">
              <i class="fas fa-home"></i>
            </span>
          </aside>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "blank",
  mounted: function() {

  },
  destroyed: function() {

  }
}

</script>
<style lang="scss" scoped>
/*@import "compass";*/

#confirmLoading {
    position: fixed;
    top:0;left:0;right:0;bottom:0;
    width:100%;
    height:100%;

  }
#wrapper {
      position: absolute;
      top:0;left:0;right:0;bottom:0;
      width:100%;
      height:100%;
      text-align:center;
      font-size:50px;
      color:#fff;
      z-index: 101;

      i {

      }
    }

.background {
  position: fixed;
  top:0;left:0;right:0;bottom:0;
  background-color: rgba(255,255,255,.6);
  z-index: 100;
}

$loader-size: 200px;
$speed: 1.5s;

@keyframes leftAnim {
  0% {
    transform: translateX(($loader-size/2)+36);
  }
  100% {
    transform: translateX(0);
    transform: rotate(-180deg);
  }
}
@keyframes rightAnim {
  0% {
    transform:translateX(0);
    transform:rotate(180deg);
  }
  100% {
    transform:translateX(-($loader-size/2)-36);
  }
}

.loader {
  width: $loader-size*2;
  height: $loader-size;
  margin: 0 auto;
  position: relative;
  z-index: 101;
  margin-top:calc((100vh - 200px) / 2);

  &::after {
    content: "";
    display: inline-block;
    position: absolute;
    left: 50%;
    margin-left: -1px;
    width: 2px;
    z-index: 1;
    height: $loader-size;
    z-index:10;
  }
  &__box {
    position: absolute;
    top: 0;
    width: $loader-size;
    height: $loader-size;
    overflow: hidden;
    z-index: 2;
  }
  &--left {
    left: 0;
    .loader__circle {
      right: 10px;
      animation: leftAnim $speed ease-in-out alternate infinite;
      
      i {
        color: #03963B;
        font-size:$loader-size/2;
        text-align:center;
      }
    }
  }
  &--right {
    right: 0;
    .loader__circle {
      left: 10px;
      animation: rightAnim $speed ease-in-out alternate infinite;
      i {
        color: #EA0000;
        font-size:$loader-size/2;
        text-align:center;
      }
    }
  }
  &__circle {
    height: $loader-size/2;
    display: block;
    //@border-radius(50%);
    position: absolute;
    top: 50%;
    margin-top: -($loader-size/2)/2;
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/house_loader.vue